function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("11r5h", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$6c3f7dbbe2d936d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9kPzn;
    var $lLLkM;
    var $az4zD;
    var $kYpAp;
    var $ieDtd;
    var $6cI1l;
    const $6c3f7dbbe2d936d5$var$CrossIconMedium = (0, (0, parcelRequire("az4zD")).injectIntlV2)((props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
            size: "medium",
            label: props.intl.formatMessage((0, (0, parcelRequire("6cI1l")).default).close)
        }));
    const $6c3f7dbbe2d936d5$var$DrawerContent = (props)=>{
        const { onClose: onClose, isAdmin: isAdmin, isOnboarding: isOnboarding, data: data, appEditions: appEditions, methods: methods, onScreenChange: onScreenChange, onPermissionsFetched: onPermissionsFetched, ProjectCreate: ProjectCreate } = props;
        const defaultSelectedTemplateKey = data.defaultSelectedTemplateKey !== undefined ? data.defaultSelectedTemplateKey : (0, (0, parcelRequire("kYpAp")).defaultProps).defaultSelectedTemplateKey;
        const isTemplatePickerOpenInitially = data.isTemplatePickerOpenInitially !== undefined ? data.isTemplatePickerOpenInitially : (0, (0, parcelRequire("kYpAp")).defaultProps).isTemplatePickerOpenInitially;
        const isImportProjectOpenInitially = data.isImportProjectOpenInitially !== undefined ? data.isImportProjectOpenInitially : (0, (0, parcelRequire("kYpAp")).defaultProps).isImportProjectOpenInitially;
        const selectedProjectType = data.selectedProjectType !== undefined ? data.selectedProjectType : (0, (0, parcelRequire("kYpAp")).defaultProps).selectedProjectType;
        let source = data.source !== undefined ? data.source : (0, (0, parcelRequire("kYpAp")).defaultProps).source;
        const [originSource] = (0, (0, parcelRequire("ieDtd")).useQueryParam)('originSource');
        if (!source && originSource !== undefined) source = originSource;
        const drawerOverrides = {
            Sidebar: {
                component: ()=>null
            },
            Content: {
                cssFn: (styles)=>({
                        ...styles,
                        margin: 0
                    })
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9kPzn")).default), {
            isOpen: data.isOpen,
            width: "full",
            onClose: onClose,
            icon: $6c3f7dbbe2d936d5$var$CrossIconMedium,
            overrides: drawerOverrides,
            autoFocusFirstElem: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(ProjectCreate, {
            isAdmin: isAdmin,
            isOnboarding: isOnboarding,
            isJswOnboarding: false,
            isJiraCoreOnboarding: false,
            skipTemplateSelection: false,
            isNextGen: data.isNextGen,
            showExperienceSelection: data.showExperienceSelection,
            recommendedTemplate: data.recommendedTemplate,
            isConnectedProjectScenario: false,
            defaultSelectedTemplateKey: defaultSelectedTemplateKey,
            isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
            isImportProjectOpenInitially: isImportProjectOpenInitially,
            selectedProjectType: selectedProjectType,
            appEditions: appEditions,
            onCancel: methods.close,
            onSuccess: methods.onSuccess,
            onScreenChange: onScreenChange,
            onPermissionsFetched: onPermissionsFetched,
            source: source,
            onDrawerClose: onClose,
            setOnCloseCallback: methods.setOnCloseCallback,
            onCreateStarted: methods.onCreateStarted,
            recommendationSessionId: data.recommendationSessionId
        }));
    };
    var $6c3f7dbbe2d936d5$export$2e2bcd8739ae039 = $6c3f7dbbe2d936d5$var$DrawerContent;
});
parcelRegister("6cI1l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$820ce6c77f07b1c9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $820ce6c77f07b1c9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        close: {
            "id": "navigation-next.project-create-drawer.close",
            "defaultMessage": "Close"
        }
    });
});
